import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    selectedCenter: null,
    selectedCourse: null,
    selectedCourseTest: null,
    selectedTitle: null,
    selectedRegion: null,
    selectedSchool: null,
    selectedLevel: null,
    selectedProvince: null,
    selectedDistrict: null,
    selectedEnroll: null,
    selectedPayment: null,
    selectedMember: null,
    selectedTest: null,
    checkedLevel: null,
    warnSelectedCenter: null,
    teacherList: null,
    courseList: null,
    scoreList: null,
    enrollmentList: null,
    memberList: null,
    examList: null,
    userData: null,
    examInfo: null,
    testType: null,


}

const mutations = {
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    },
    setUserData(state, newData) {
        state.userData = newData;
    },
    setSelectedScenter(state, newData) {
        state.selectedCenter = newData
    },
    setSelectedLevel(state, newData) {
        state.selectedLevel = newData
    },
    setWarnSelectedCenter(state, newData) {
        state.swarnSelectedCenter = newData
    },
    setSelectedCourse(state, newData) {
        state.selectedCourse = newData
    },
    setSelectedCourseTest(state, newData) {
        state.selectedCourseTest = newData
    },
    setSelectedTitle(state, newData) {
        state.selectedTitle = newData
    },
    setSelectedRegion(state, newData) {
        state.selectedRegion = newData
    },
    setSelectedSchool(state, newData) {
        state.selectedSchool = newData
    },
    setSelectedProvince(state, newData) {
        state.selectedProvince = newData
    },
    setSelectedDistrict(state, newData) {
        state.selectedDistrict = newData
    },
    setSelectedEnroll(state, newData) {
        state.selectedEnroll = newData
    },
    setSelectedPayment(state, newData) {
        state.selectedPayment = newData
    },
    setSelectedMember(state, newData) {
        state.selectedMember = newData
    },
    setSelectedTest(state, newData) {
        state.selectedTest = newData
    },
    setCheckedLevel(state, newData) {
        state.checkedLevel = newData
    },
    setTeacherList(state, newData) {
        state.teacherList = newData
    },
    setCourseList(state, newData) {
        state.courseList = newData
    },
    setScoreList(state, newData) {
        state.scoreList = newData
    },
    setEnrollmentList(state, newData) {
        state.enrollmentList = newData
    },
    setMemberList(state, newData) {
        state.memberList = newData
    },
    setExamList(state, newData) {
        state.examList = newData
    },
    setExamInfo(state, newData) {
        state.examInfo = newData
    },
    setTestType(state, newData) {
        state.testType = newData
    },

}

export default new Vuex.Store({
    state,
    mutations,
})